import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Compass, MapPin, Sparkles, CircleCheck } from "lucide-react";
export default function Disciplinesintro() {
  const keyPoints = [{
    text: "Geïntegreerde aanpak van alle disciplines"
  }, {
    text: "Directe vertaling van data naar actie"
  }, {
    text: "Focus op structurele rendementsverbetering"
  }, {
    text: "Ondersteuning als extern hoofdkantoor"
  }];
  return;
}